import React from 'react';
import BackgroundYoutube from '../BackgroundVideo/BackgroundYoutube';
import hasBackgroundTrailer from '../hoc/hasBackgroundTrailer';
import getBackgroundStyles from '../functions/getBackgroundStyles';


const BackgroundVideo = ({youtubeId, isInViewport, hasYoutubeCookieConfirmation, backgroundImage = false, isMobile = false, isReady, videoLoaded, trailerTime, onPlayerReady, onPlayerStateChange, onPlayerEnd, onPlayerUmount}) => {
    const hasYouTubeComponent = isInViewport && true === hasYoutubeCookieConfirmation && isReady
    const hasImgComponent = !hasYouTubeComponent || !videoLoaded
 
    return (
        <div className='background-video-wrapper'>
            {hasYouTubeComponent && 
                <div className="trailer-content background-video-video">
                    <BackgroundYoutube
                        youtubeId={youtubeId}
                        onPlayerReady={onPlayerReady}
                        onPlayerStateChange={onPlayerStateChange}
                        onPlayerEnd={onPlayerEnd}
                        onPlayerUmount={onPlayerUmount}
                        trailerTime={trailerTime}
                    />
                </div>
            }

            {backgroundImage && <div
                className='image background-visuals-container background-video-fallback-image'
                style={{
                    ...getBackgroundStyles(backgroundImage, true, isMobile),
                    opacity: hasImgComponent ? 1 : 0,
                    transitionDuration: hasImgComponent ? '0s' : '2s'
                }}
            >
            </div>}
        </div>
    )
}

export default hasBackgroundTrailer(BackgroundVideo)